import { SET_META_PIXELS } from '../../constants/actions';

const initialState = {
  fbc: null,
  fbp: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_META_PIXELS:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
}
